'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObservable = require('is-observable');

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return typeof value === 'function' || (0, _isObservable2['default'])(value);
};


//////////////////
// WEBPACK FOOTER
// ./~/jss/lib/utils/isDynamicValue.js
// module id = 11
// module chunks = 0